import { config as configPresets } from "../../components/DebugTools/configPresets";

/** The locales the developer portal serves; any other interface language opens the English pages. */
const DEVELOPER_PORTAL_LOCALES = ["nl", "en", "de", "fr", "es"] as const;
const DEVELOPER_PORTAL_FALLBACK_LOCALE = "en";

export interface DeveloperPortalLinks {
  reference: string
  webhooks: string
}

/**
 * The developer portal base URL of a build's config preset (`VITE_CONFIG_PRESET_NAME`, set per environment by the
 * deploy), for a build that does not set `VITE_DEVELOPER_URL` itself.
 */
export function developerUrlForPreset(presetName: string | null | undefined): string | null {
  if (!presetName) {
    return null;
  }

  return configPresets.web[presetName]?.developerUrl ?? null;
}

export function developerPortalLocale(locale: string): string {
  const language = locale.split("-")[0]?.toLowerCase() ?? "";

  return (DEVELOPER_PORTAL_LOCALES as readonly string[]).includes(language) ? language : DEVELOPER_PORTAL_FALLBACK_LOCALE;
}

/** The API reference and the webhooks guide on the developer portal, or null when the environment has no portal. */
export function developerPortalLinks(developerUrl: string | null | undefined, locale: string): DeveloperPortalLinks | null {
  if (!developerUrl) {
    return null;
  }

  const base = `${developerUrl.replace(/\/+$/, "")}/${developerPortalLocale(locale)}`;

  return {
    reference: `${base}/reference`,
    webhooks: `${base}/v1/webhooks`,
  };
}
